export default class RegisterData {
    email = ''
    password = ''
    repeatPassword = ''
    consent = false
}
